// extracted by mini-css-extract-plugin
module.exports = {"page":"page__1zl6_","page-inner":"page-inner__1i36G"};